module.exports = "<app-master-menu></app-master-menu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master.component.html
// module id = ./src/app/master/master.component.html
// module chunks = main